import React from 'react';

import ListPageHeader from '@shared/ListPageHeader';
import ProductSerialNumberList from '@shared/product_serial_numbers/ProductSerialNumberList';

import { useOperatorProductSerialNumberService } from '@hooks/operator/product_serial_numbers/useOperatorProductSerialNumberService';
import { useOperatorProductService } from '@hooks/operator/products/useOperatorProductService';

/**
 * Operator Product Serial Numbers — 序號 (PSN) identity-centric 列表頁。
 *
 * 直接使用 shared/product_serial_numbers/ProductSerialNumberList，
 * 透過 useOperatorProductSerialNumberService 注入 service。
 * 同步注入 useOperatorProductService 讓「商品多選 filter」(lazyLoad) 出現。
 *
 * 麵包屑 / 標題 透過 ListPageHeader 自動由 menuConfig 的 labelKey 產生。
 * ListPageHeader 的 basePath 預設為 '/operator'，這裡不用顯式傳。
 *
 * role="operator" 用來讓 Drawer / Timeline 產生 operator 路徑的 link；
 * filter 行為 admin / operator 對齊（含跨倉、跨狀態查詢）。
 */
const OperatorProductSerialNumbersList: React.FC = () => {
  const service = useOperatorProductSerialNumberService();
  const productService = useOperatorProductService();

  return (
    <div>
      <ListPageHeader items={['products', 'products.serial_numbers']} />
      <ProductSerialNumberList
        role="operator"
        service={service}
        productService={productService}
      />
    </div>
  );
};

export default OperatorProductSerialNumbersList;
